import { Input, Select } from "antd"
import React, { useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "../../Setting/common/styled"

const FilterSim = () => {
  const inputSearchRef = useRef()

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent : "space-between",
        alignItems: "center",
        marginBottom: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        <Input placeholder="Số lô nhập" style={{ width: 130 }} />
        <Select
          placeholder={
            <span style={{ color: "#bfbfbf", fontWeight: 380 }}>
              Nhà cung cấp
            </span>
          }
          allowClear
          style={{ width: 170, height: "37px" }}
        >
          <Select.Option value="viettel">Viettel</Select.Option>
          <Select.Option value="vinaphone">Vinaphone</Select.Option>
          <Select.Option value="mobifone">Mobifone</Select.Option>
        </Select>

        <Select
          placeholder={
            <span style={{ color: "#bfbfbf", fontWeight: 380 }}>Nhà mạng</span>
          }
          allowClear
          style={{ width: 150 }}
        >
          <Select.Option value="viettel">Viettel</Select.Option>
          <Select.Option value="vinaphone">Vinaphone</Select.Option>
          <Select.Option value="mobifone">Mobifone</Select.Option>
        </Select>

        <Select
          placeholder={
            <span style={{ color: "#bfbfbf", fontWeight: 380 }}>
              Trạng thái
            </span>
          }
          allowClear
          style={{ width: 150 }}
        >
          <Select.Option value="new">Mới nhập</Select.Option>
          <Select.Option value="used">Đã sử dụng</Select.Option>
          <Select.Option value="cancel">Hủy</Select.Option>
        </Select>

        <CustomRangePicker style={{ width: 250 }} format="DD/MM/YYYY" />
      </div>
      <div>
        <InputSearchStyle>
          <Input
            className="custom-input"
            maxLength={50}
            placeholder="Tìm kiếm"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            // onPressEnter={onSearch}
            size="small"
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" />
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}
export default FilterSim
